<template>
  <div id="fulfillment-privilege-list">
    <b-card no-body class="p-2 container-card mb-1">
      <b-row>
        <b-col cols="12" class="px-2 mb-1">
          <div>
            <div class="d-flex justify-content-end mb-1">
              <add-button
                v-if="getPermissionModule('Fulfillment').adjust"
                :btn-label="'Import Tracking'"
                @click.native="$router.push('/fulfillment/import/list/')"
              />
              <export-button v-if="getPermissionModule('Fulfillment').adjust" class="ml-2" @onExport="onOpenExportModal" />
            </div>
            <div class="d-flex flex-wrap justify-content-end">
              <v-select
                id="fulfillment-type-status"
                v-model="form.status"
                class="v-select-filter bg-fulfillment-list"
                :class="form.status ? 'v-select-filter-selected' : null"
                placeholder="Status"
                :options="statusOption"
                @input="(option) => onSelectFilter('shipping_status', option)"
              />

              <div class="search-container mb-1 mb-md-0 mr-0 ml-0 ml-1">
                <search :on-search-input="onSetValueSearch" />
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12" class="mb-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :fields="fields"
                :items="fulfillmentListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table"
              > -->
              <b-table
                :fields="fields"
                :items="fulfillmentListTable.payload"
                responsive
                bordered
                borderless
                sticky-header
                show-empty
                class="default-static-table-vertical"
              >
                <template #head(transaction_txref)="data">
                  <div class="text-left col-order">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(transaction_txref)="data">
                  <div>{{ data.value || "-" }}</div>
                </template>
                <template #head(privilege_alt_ref)="data">
                  <div class="text-left">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(privilege_alt_ref)="data">
                  <div class="">
                    {{ data.value || "-" }}
                  </div>
                </template>
                <template #cell(mobile_no)="data">
                  <div class="">
                    {{ data.item.customer_mobile || "-" }}
                  </div>
                </template>
                <template #cell(first_name)="data">
                  <div class="">
                    {{ data.item.customer_first_name_th || "-" }}
                  </div>
                </template>
                <template #cell(last_name)="data">
                  <div class="">
                    {{ data.item.customer_last_name_th || "-" }}
                  </div>
                </template>
                <template #cell(privilege_type)="data">
                  <div v-if="data.item.privilege_type == 1" class="">
                    {{ "Reward/privilege (RP)" }}
                  </div>
                  <div v-if="data.item.privilege_type == 4">
                    {{ "Coupon code (CPC)" }}
                  </div>
                </template>
                <template #head(privilege_name_th)="data">
                  <div class="text-left font-weight">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(customer_name_th)="data">
                  <div class="col-name">
                    {{ data.value || "-" }}
                  </div>
                </template>
                <template #head(shipping_status)="data">
                  <div class="text-left font-weight">
                    {{ data.label }}
                  </div>
                </template>
                <template #cell(shipping_status)="data">
                  <div class="col-shipping">
                    <div
                      class="status-badge text-center text-white"
                      :class="[
                        resolveClassShippingStatus(data.item.shipping_status),
                      ]"
                    >
                      {{ resolveShippingStatus(data.item.shipping_status) }}
                    </div>
                  </div>
                </template>
                <template #cell(issue_date)="data">
                  <div class="col-date text-center">
                    {{
                      data.value
                        ? resolveDate(data.value) +
                          " " +
                          resolveFullTime(data.value)
                        : "-"
                    }}
                  </div>
                </template>
                <template #cell(updated_dt)="data">
                  <div class="col-date text-center">
                    {{
                      data.value
                        ? resolveDate(data.value) +
                          " " +
                          resolveFullTime(data.value)
                        : "-"
                    }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <div class="col-fulfillment-list d-flex status">
                    <span class="text-center">
                      <img
                        v-b-tooltip.hover
                        src="~@/assets/images/icons/shipping.png"
                        class="w-40 cursor-pointer iconSvg-btn"
                        title="Shipment Tracking"
                        @click="
                          openShippingDetailModal(data.item.ticket_id, true)
                        "
                      />
                    </span>
                    <span />
                  </div>
                </template>
                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>
                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>
      </b-row>
    </b-card>
    <shipping-detail-modal
      v-if="modalType.manageShippingDetail"
      :is-edit="isEditData"
      :isAdjusted="getPermissionModule('Fulfillment').adjust"
      :data-obj="shippingDetailObj"
      :loading="loading.formData"
      @onSubmit="saveDataModal"
      @onCloseModal="closeShippingDetailModal"
      @fetchFulfillmentList="fetchFulfillmentList"
    />

    <history-report-modal
      v-if="modalPopup.report"
      @onCloseModal="closeReportModal"
      :moduleTypeKey="defaultReportFilterType.module"
      :moduleKey="defaultReport.fulfillment"
    />
  </div>
</template>

<script>
import {
  BCol,
  BCard,
  BTable,
  BFormCheckbox,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";

import AddButton from "@/views/components/button/AddButton.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import EditIcon from "@/@core/components/svg/common/Edit.vue";
import DeleteIcon from "@/@core/components/svg/common/Trash.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useFulfillmentList from "../hooks/useFulfillmentList";

import ShippingDetailModal from "../../fulfillment-detail/FulfillmentDetail.vue";
import ExportButton from "@/views/components/button/ExportButton.vue";
import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

export default {
  components: {
    BCol,
    BCard,
    BTable,
    BFormCheckbox,
    BRow,
    BSpinner,
    CardNoItem,
    AddButton,
    Search,
    vSelect,
    EditIcon,
    DeleteIcon,
    ShippingDetailModal,
    PaginationWithReorder,
    ExportButton,
    HistoryReportModal,
  },
  setup() {
    const {
      fields,
      loading,
      statusOption,
      form,
      fulfillmentListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      fetchFulfillmentList,

      isEditData,
      modalType,
      shippingDetailObj,
      openShippingDetailModal,
      closeShippingDetailModal,
      saveDataModal,
      resolveShippingStatus,
      resolveClassShippingStatus,
      resolveDate,
      resolveFullTime,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    } = useFulfillmentList();

    return {
      fields,
      loading,
      statusOption,
      form,
      fulfillmentListTable,
      pagination,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      onSelectFilter,
      fetchFulfillmentList,

      isEditData,
      modalType,
      shippingDetailObj,
      openShippingDetailModal,
      closeShippingDetailModal,
      saveDataModal,
      resolveShippingStatus,
      resolveClassShippingStatus,
      resolveDate,
      resolveFullTime,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      modalPopup,
      onOpenExportModal,
      closeReportModal,
      getPermissionModule
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/fulfillment/fulfillment-list.css";
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.iconSvg-btn {
  border-radius: 50%;
}
</style>
